import { render } from "./HostingFeatures.vue?vue&type=template&id=57ba3025"
import script from "./HostingFeatures.vue?vue&type=script&lang=js"
export * from "./HostingFeatures.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__